let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iFaWe")).then(() => parcelRequire('LiaMl'));